import React from "react";
import { Scale, BookOpen, Calendar, ArrowRight } from "lucide-react";
import { Badge } from "./ui/badge";
import { useTranslation } from "react-i18next";

export const LegalContext = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 lg:py-28 bg-white grain-texture" id="contexto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="section-reveal">
            <Badge className="bg-[#F5F1EA] text-[#C8A24D] border-[#E8D5A0] hover:bg-[#F5F1EA] mb-6 py-1.5 px-4 text-xs font-semibold tracking-wide uppercase">
              {t("legalContext.badge")}
            </Badge>
            <h2 className="text-3xl sm:text-4xl lg:text-[42px] text-[#0C2340] leading-tight mb-6" style={{ fontFamily: "'DM Serif Display', serif" }}>
              {t("legalContext.title")}
            </h2>
            <p className="text-lg text-[#4A5568] leading-relaxed mb-8">
              {t("legalContext.body")}
            </p>
            <div className="space-y-6 !my-[6px]">
              {[
              { icon: Scale, text: t("legalContext.point1") },
              { icon: Calendar, text: t("legalContext.point2") },
              { icon: BookOpen, text: t("legalContext.point3") }].
              map((item, id) =>
              <div key={id} className="flex items-start gap-4 group">
                  <div className="w-10 h-10 rounded-lg bg-[#F5F1EA] flex items-center justify-center shrink-0 group-hover:bg-[#0C2340] transition-colors duration-300">
                    <item.icon className="w-5 h-5 text-[#C8A24D] group-hover:text-[#E8D5A0] transition-colors duration-300" />
                  </div>
                  <p className="text-[#4A5568] text-base leading-relaxed pt-1.5">{item.text}</p>
                </div>
              )}
            </div>
          </div>

          {/* Right Side - Visual Card */}
          <div className="section-reveal">
            <div className="relative">
              <div className="bg-gradient-to-br from-[#0C2340] to-[#1B3A5C] rounded-3xl p-8 sm:p-10 lg:p-12 text-white overflow-hidden">
                {/* Decorative elements */}
                <div className="absolute top-0 right-0 w-48 h-48 bg-[#C8A24D]/10 rounded-full -translate-y-1/2 translate-x-1/2" />
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#C8A24D]/5 rounded-full translate-y-1/2 -translate-x-1/2" />
                
                <div className="relative z-10">
                  <div className="w-14 h-14 rounded-2xl bg-[#C8A24D]/20 flex items-center justify-center mb-6">
                    <Scale className="w-7 h-7 text-[#E8D5A0]" />
                  </div>
                  <h3 className="text-2xl sm:text-3xl text-white mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                    {t("legalContext.cardTitle")}
                  </h3>
                  <p className="text-white/70 text-base leading-relaxed mb-8">
                    {t("legalContext.cardBody")}
                  </p>
                  <div className="flex items-center gap-3 bg-white/10 rounded-xl p-4 backdrop-blur-sm border border-white/10">
                    <div className="w-10 h-10 rounded-full bg-[#C8A24D] flex items-center justify-center shrink-0">
                      <ArrowRight className="w-5 h-5 text-[#0C2340]" />
                    </div>
                    <div>
                      <p className="text-white text-sm font-semibold">{t("legalContext.cardTag1")}</p>
                      <p className="text-white/60 text-xs">{t("legalContext.cardTag2")}</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Shadow accent */}
              <div className="absolute -bottom-3 left-6 right-6 h-6 bg-[#0C2340]/20 blur-xl rounded-3xl" />
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default LegalContext;